import {useIntl} from "react-intl";
import {CircleUser, MessageSquare, Phone, Settings, Siren, Users} from "lucide-react";
import type {ReactNode} from "react";
import logoItem from './../assets/logo.svg';
import {Colors} from "./types/Types";

// Lucide icons for the navigation rail (Design System NavRail).
const railIcon = (Icon: typeof Phone): ReactNode => <Icon size={20} aria-hidden="true" className="!p-0 !text-current"/>;


const sidebarItems = [
    {
        icon: 'call',
        railIcon: railIcon(Phone),
        labelId: 'calls.menu',
        link: '/calls',
    },
    {
        icon: 'chat',
        railIcon: railIcon(MessageSquare),
        labelId: 'chat.menu',
        link: '/chat',
    },
    {
        icon: 'account_circle',
        railIcon: railIcon(CircleUser),
        labelId: 'contacts.menu',
        link: '/contacts',
    },
    {
        icon: 'group',
        railIcon: railIcon(Users),
        labelId: 'team.menu',
        link: '/team',
    },
];

const sidebarSettingsItems = [
    {
        icon: 'settings',
        railIcon: railIcon(Settings),
        labelId: 'settings.menu',
        link: '/settings',
    },
];



export const sections = [
    {
        items: sidebarItems,
    },

    {
        title: 'Settings',
        items: sidebarSettingsItems,
    },

];


export const user = {
    name: '',
    iconColor: Colors.green,
    email: '',
    dnd: false,
};


// Emergency Notifications get an Alerts item above Settings (mockup decision Z33):
// admins manage alerts, everyone else sees the alerts sent to them.
const alertsItem = (isAdmin: boolean) => ({
    icon: 'crisis_alert',
    railIcon: railIcon(Siren),
    labelId: 'alerts.menu',
    link: isAdmin ? '/admin/ens' : '/ens/my-alerts',
});

export const translateSections = ({isChatEnabled, isEnsEnabled = false, isAdmin = false}: {
    isChatEnabled: boolean;
    isEnsEnabled?: boolean;
    isAdmin?: boolean;
}) => {
    const intl = useIntl();

    const translatedSections = sections.map(section => ({
        ...section,
        items: (section.items === sidebarSettingsItems && isEnsEnabled ? [alertsItem(isAdmin), ...section.items] : section.items)
            .filter(item => isChatEnabled || item.labelId !== 'chat.menu')
            .map(item => ({
                ...item,
                label: intl.formatMessage({ id: item.labelId }),
            })),
    }));

    return translatedSections;
};

export const logo = <img width={36} height={36} src={logoItem} alt=""/>;
